import React, { useState, useEffect, useContext } from 'react';
import ReactDatetimeClass from 'react-datetime';

import EmpresaContext from "../../../contexts/Empresa";
import api from "../../../services/api";
import { usePersistedState } from '../../../hooks';
import moment from 'moment';

import Select2 from "react-select2-wrapper";
import Filters from '../../../components/Headers/Filters';
import {
    Input,
    Row,
    Col,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Label,
} from "reactstrap";

export default ({ title, notify, load, ...props }) => {

    const { empresaSelecionada } = useContext(EmpresaContext)

    const [empresasList, setEmpresasList] = useState([])
    const [empresasNps, setEmpresasNps] = usePersistedState('empresasNps', [])

    const [userMalasDiretasNps, setUsersMalasDiretasNps] = usePersistedState('usersMalasDiretasNps', [])
    const [usersComboBox, setUsersComboBox] = useState([])

    const [situacaoMalasDiretasNps, setSituacaoMalasDiretasNps] = usePersistedState('situacaoMalasDiretasNps', [])

    const [dataAgendamentoInicialMalasDiretasNps, setDataAgendamentoInicialMalasDiretasNps] = usePersistedState('dataAgendamentoInicialMalasDiretasNps', null)
    const [dataAgendamentoFinalMalasDiretasNps, setDataAgendamentoFinalMalasDiretasNps] = usePersistedState('dataAgendamentoFinalMalasDiretasNps', null)

    const [dataCriacaoInicialNps, setDataCriacaoInicialNps] = usePersistedState('dataCriacaoInicialNps', getDataAgendamentoInicial())
    const [dataCriacaoFinalNps, setDataCriacaoFinalNps] = usePersistedState('dataCriacaoFinalNps', getDataAgendamentoFinal())

    const [nota, setNota] = usePersistedState('notaNps', null);

    //Flag para definir tempo de execução
    const [runLoad, setRunLoad] = useState(props.search ? props.search : true)
    const [monitorClearFilters, setMonitorClearFilters] = useState(undefined)

    useEffect(() => {
        if (monitorClearFilters) search()
    }, [monitorClearFilters])

    useEffect(() => {
        if (runLoad) {
            search()
            setRunLoad(false)
        }
    }, [runLoad])

    useEffect(() => {
        if (empresasList && empresasList.length === 0) loadEmpresas()
    }, [])

    useEffect(() => {
        if (empresasNps && empresasNps.length > 0) {
            loadUserByEmpresaBox()
        } else {
            loadUser()
        }

    }, [empresasNps])

    function getDataAgendamentoInicial() {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth());
    }

    function getDataAgendamentoFinal() {
        const date = new Date();
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    async function loadEmpresas() {
        try {
            const response = await api.get('security/sessions/empresas')
            if (response.data) {
                setEmpresasList(response.data)
            }
        } catch (error) {
            console.log(error)
            throwError('Não foi possível carregar empresas')
        }
    }


    async function loadUser() {
        try {
            const response = await api.get(`common/empresas/${empresaSelecionada?.id}/colaboradores`)
            setUsersComboBox(await response.data)
        } catch (error) {
            console.error(error)
        }
    }

    async function loadUserByEmpresaBox() {
        try {
            const response = await api.get(`common/empresas/${empresaSelecionada?.id}/colaboradoresbyempresas`,
                {
                    params: {
                        empresa_id: empresasNps,
                        empresas: empresasNps
                    }
                }
            )
            setUsersComboBox(await response.data)
        } catch (error) {
            console.error(error)
        }
    }

    function throwError(text) {
        if (notify) notify('danger', text)
    }

    async function search() {
        await load({
            empresa_id: empresasNps ? empresasNps : [],
            colaboradores: userMalasDiretasNps ? userMalasDiretasNps : [],
            situacoes: situacaoMalasDiretasNps ? situacaoMalasDiretasNps : [],
            data_inicio_agendamento_maladireta: dataAgendamentoInicialMalasDiretasNps,
            data_fim_agendamento_maladireta: dataAgendamentoFinalMalasDiretasNps,
            data_inicio_criacao_nps: dataCriacaoInicialNps,
            data_fim_criacao_nps: dataCriacaoFinalNps,
            nota: nota
        })
    }

    function handleMultipleSelect(target, state) {
        const array = Array.from(target.selectedOptions);
        state(array.map((item) => item.value));
    }

    async function clearFilters() {
        setDataAgendamentoInicialMalasDiretasNps(null);
        setDataAgendamentoFinalMalasDiretasNps(null);

        setEmpresasNps([]);
        setUsersMalasDiretasNps([]);
        loadUser();
        setSituacaoMalasDiretasNps([]);

        setDataCriacaoInicialNps(null);
        setDataCriacaoFinalNps(null);

        setNota(null);

    }

    return (
        <>
            <Filters
                onSearch={search}
                title={title}
                clearFilters={clearFilters}
                onFiltersClead={setMonitorClearFilters}
            >
                <Row>
                    {/*<Col xs={4}>
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="example-number-input"
                            >
                                Empresas
                            </label>
                            <InputGroup className="input-group-alternative">
                                <Select2
                                    multiple
                                    onSelect={(e) => handleMultipleSelect(e.target, setEmpresasNps)}
                                    onUnselect={(e) => handleMultipleSelect(e.target, setEmpresasNps)}
                                    options={{
                                        placeholder: "Selecione as Empresas"
                                    }}
                                    value={empresasNps}
                                    data=
                                    {
                                        empresasList.sort(function (a, b) { return (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : ((b.nome.toLowerCase() > a.nome.toLowerCase()) ? -1 : 0) }).map((item) => (
                                            {
                                                id: item.id,
                                                text: item.nome
                                            }
                                        ))
                                    }
                                />
                            </InputGroup>
                        </FormGroup>
                    </Col>


                    <Col xs={4}>
                        <FormGroup>
                            <Label for="exampleSelect">Colaboradores</Label>
                            <InputGroup className="input-group-alternative">
                                <Select2
                                    multiple
                                    onSelect={(e) => handleMultipleSelect(e.target, setUsersMalasDiretasNps)}
                                    onUnselect={(e) => handleMultipleSelect(e.target, setUsersMalasDiretasNps)}
                                    options={{
                                        placeholder: "Selecione colaboradores"
                                    }}
                                    value={userMalasDiretasNps}
                                    data={
                                        //usersComboBox.map((item) => ({ id: item.id, text: item.name }))
                                        usersComboBox.sort(function (a, b) { return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0) }).map((item) => (
                                            {
                                                id: item.id,
                                                text: item.name
                                            }
                                        ))
                                    }
                                />
                            </InputGroup>
                        </FormGroup>
                    </Col> */}

                    <Col xs={4}>
                        <FormGroup>
                            <Label for="exampleSelect">Situação Mala Direta</Label>
                            <Select2
                                className="form-control"
                                //@ts-ignore
                                //onSelect={(e) => setSituacao(e.target.value)}
                                multiple
                                onSelect={(e) => handleMultipleSelect(e.target, setSituacaoMalasDiretasNps)}
                                onUnselect={(e) => handleMultipleSelect(e.target, setSituacaoMalasDiretasNps)}
                                value={situacaoMalasDiretasNps}
                                options={{
                                    placeholder: "Selecione Situações"
                                }}
                                data={[
                                    { id: 'ativo', text: 'Ativo' },
                                    { id: 'inativo', text: 'Inativo' },
                                    { id: 'em-andamento', text: 'Em Andamento' },
                                    { id: 'cancelado', text: 'Cancelado'},
                                    { id: 'concluido', text: 'Concluído'}
                                ]}
                            />
                        </FormGroup>
                    </Col>

                </Row>

                <Row>


                    <Col xs="auto" lg="6" sm="6" md="6">
                        <fieldset className="border p-2">
                            <legend className="w-auto" style={{ margin: 0 }}>
                                <label
                                    className="form-control-label"
                                >
                                    Data Agendamento Mala Direta
                                        </label>
                            </legend>
                            <Row>
                                <Col xs={6}>
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example-number-input"
                                        >
                                            Início
                                        </label>
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-calendar-grid-58" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <ReactDatetimeClass
                                                inputProps={{
                                                    placeholder: "Início",
                                                    style: {
                                                        width: '100px'
                                                    }
                                                }}
                                                //COMENTADO PORQUE É TESTE DE DATA
                                                value={moment(dataAgendamentoInicialMalasDiretasNps)}
                                                dateFormat="DD/MM/YYYY"
                                                timeFormat={false}
                                                renderDay={(props, currentDate, selectedDate) => {
                                                    let classes = props.className;
                                                    if (
                                                        dataAgendamentoInicialMalasDiretasNps &&
                                                        dataAgendamentoFinalMalasDiretasNps &&
                                                        dataAgendamentoInicialMalasDiretasNps._d + "" === currentDate._d + ""
                                                    ) {
                                                        classes += " start-date";
                                                    } else if (
                                                        dataAgendamentoInicialMalasDiretasNps &&
                                                        dataAgendamentoFinalMalasDiretasNps &&
                                                        new Date(dataAgendamentoInicialMalasDiretasNps._d + "") <
                                                        new Date(currentDate._d + "") &&
                                                        new Date(dataAgendamentoFinalMalasDiretasNps._d + "") >
                                                        new Date(currentDate._d + "")
                                                    ) {
                                                        classes += " middle-date";
                                                    } else if (
                                                        dataAgendamentoFinalMalasDiretasNps &&
                                                        dataAgendamentoFinalMalasDiretasNps._d + "" === currentDate._d + ""
                                                    ) {
                                                        classes += " end-date";
                                                    }
                                                    return (
                                                        <td {...props} className={classes}>
                                                            {currentDate.date()}
                                                        </td>
                                                    );
                                                }}
                                                onChange={e => setDataAgendamentoInicialMalasDiretasNps(e)}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col xs={6}>
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example-number-input"
                                        >
                                            Fim
                                                </label>
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-calendar-grid-58" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <ReactDatetimeClass
                                                inputProps={{
                                                    placeholder: "Fim",
                                                    style: {
                                                        width: '100px'
                                                    }
                                                }}
                                                value={moment(dataAgendamentoFinalMalasDiretasNps)}
                                                dateFormat="DD/MM/YYYY"
                                                timeFormat={false}
                                                renderDay={(props, currentDate, selectedDate) => {
                                                    let classes = props.className;
                                                    if (
                                                        dataAgendamentoInicialMalasDiretasNps &&
                                                        dataAgendamentoFinalMalasDiretasNps &&
                                                        dataAgendamentoInicialMalasDiretasNps._d + "" === currentDate._d + ""
                                                    ) {
                                                        classes += " start-date";
                                                    } else if (
                                                        dataAgendamentoInicialMalasDiretasNps &&
                                                        dataAgendamentoFinalMalasDiretasNps &&
                                                        new Date(dataAgendamentoInicialMalasDiretasNps._d + "") <
                                                        new Date(currentDate._d + "") &&
                                                        new Date(dataAgendamentoFinalMalasDiretasNps._d + "") >
                                                        new Date(currentDate._d + "")
                                                    ) {
                                                        classes += " middle-date";
                                                    } else if (
                                                        dataAgendamentoFinalMalasDiretasNps &&
                                                        dataAgendamentoFinalMalasDiretasNps._d + "" === currentDate._d + ""
                                                    ) {
                                                        classes += " end-date";
                                                    }
                                                    return (
                                                        <td {...props} className={classes}>
                                                            {currentDate.date()}
                                                        </td>
                                                    );
                                                }}
                                                onChange={e => setDataAgendamentoFinalMalasDiretasNps(e)}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </fieldset>
                    </Col>

                </Row>

            </Filters>
        </>
    );

}